export default __webpack_public_path__ + "static/media/forward-arrow.a1d07688.svg";